module.exports = __webpack_public_path__ + "img/pauli-z-root-16.19e28c29.svg";